import React from 'react';
import { OPEN_DIALOG, CONFIRM_DIALOG, CANCEL_DIALOG } from 'stash/actions/dialog';

const dialog = (state = { open: false }, action) => {
  switch (action.type) {
    case OPEN_DIALOG: {
      const { prompt, ...restAction } = action;
      const safePrompt = React.isValidElement(prompt)
        ? prompt
        : typeof prompt === 'object'
        ? JSON.stringify(prompt)
        : prompt;

      return {
        ...restAction,
        open: true,
        prompt: safePrompt,
      };
    }
    case CONFIRM_DIALOG:
      return {
        open: false,
      };
    case CANCEL_DIALOG:
      return {
        open: false,
      };
    default:
      return state;
  }
};

export default dialog;
